module.exports = __webpack_public_path__ + "static/img/bodadianhua.123ca52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bodadianhua.png
// module id = gK42
// module chunks = 208